<div class="flex items-center justify-between">
  <h1
    class="pb-5 font-brand text-28px font-bold text-neutral-800"
    translate="como.link-account.header"
  ></h1>
  <app-rounded-icon-button
    icon="icon-cross"
    (onClick)="onClose.emit($event)"
  ></app-rounded-icon-button>
</div>

<form>
  <label
    for="phone"
    class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600"
    translate="signup.phone"
  ></label>

  <app-kiosk-input-country-phone-atom
    id="phone"
    [phone]="phone()"
    [useLocalFormat]="useLocalFormat()"
    [defaultRegionCode]="defaultRegionCode()"
    [helpTranslateKey]="'como.help-phone-format'"
    (updatePhone)="phone.set($any($event))"
    (keydown)="handleKeyDown($event)"
  />

  <div class="hidden kiosk:block">
    <app-numeric-keypad-atom
      (numberClick)="onKeypadNumberClick($event)"
      (deleteClick)="onKeypadDeleteClick()"
    ></app-numeric-keypad-atom>
  </div>

  @if (errorMessage) {
    <div
      class="mt-2 font-base text-xs font-normal text-error-700"
      [translate]="errorMessage"
    ></div>
  }

  <div class="mt-10 flex flex-col">
    <app-button-atom
      size="L"
      [label]="'como.validate' | translate"
      [iconUrl]="isValidating ? 'assets/images/spinner.svg' : ''"
      [disabled]="isValidating || !phone()"
      type="primary"
      [overrideBgColor]="accentColor?.background"
      [full]="true"
      (click)="onRegister()"
    ></app-button-atom>
  </div>
</form>
